module.exports = __webpack_public_path__ + "img/active-directory.45c9f9a8.svg";